<template>
    <div v-if="visible">
      <h4 class="table-title">
        <span>{{ title  }} ({{ count }})</span>
        <div class="botones-header">

        
        <button 
        
        v-if="!groupsModified[groupId]  && mensajeDisponible && !fechaCorte && grupo_activo == 1" 
        @click="enviarPreinvitacionGrupal" 
        class="bg-purple-600 hover:bg-purple-800 text-white font-bold py-3 px-3 rounded mr-5 boton-grupal-pre-invitacion"
      >
        Enviar invitación grupal

      </button>

        <button v-if="!fechaCorte && grupo_activo == 1" @click="triggerFileInput" :class="buttonClasses" class="bg-green-500 hover:bg-green-700 mr-5 button-excel text-white font-bold py-1 px-3 rounded">
          <div v-if="loading">
            <!-- Procesando SVG -->
            <ProcesandoExcel />
          </div>
          <div v-else>
            <!-- Estado inicial SVG -->
            <EstadoInicialExcel />
          </div>
        </button>
        
        <button v-if="!fechaCorte && grupo_activo == 1"  @click="performSave" class="button-save">
          <IconoConGuardar />
        </button>
        
        
        <input v-if="!fechaCorte" type="file" @change="handleFileChange" style="display: none" :id="'file-input-' + category + '-' + groupId">
      </div>
        <!-- <button  @click="toggleAccordion" class="rotate-button">
          <div :class="{'rotate-180': isOpen}">
            <FlechaRotativa />
          </div>
        </button> -->
      </h4>
      <div v-show="isOpen" class="accordion-content min-w-full divide-y divide-gray-200">
        <div class="contenedor-general-usuarios">
          <div class="contenedor-usuarios" v-for="(member, index) in members" :key="`${category}-${index}`">
            <div v-if="(isFieldActive('nombres') || isFieldActive('apellidos')) || isFieldActive('departamento'|| isFieldActive('numero_de_documento') || isFieldActive('tipo_de_documento') || isFieldActive('categoria')) ">



                <div v-if="isFieldActive('nombres')" class="grid-input-row">
                    <label >Nombres</label>
                    <input v-model="member.nombres" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
                <div v-if="isFieldActive('apellidos')" class="grid-input-row">
                    <label >Apellidos</label>
                    <input v-model="member.apellidos" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
                <div v-if="isFieldActive('departamento')" class="grid-input-row">
                    <label >Departamento</label>
                    <input v-model="member.departamento" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                    
                </div>
          


                <div v-if="isFieldActive('numero_de_documento')" class="grid-input-row">
                    <label >Documento</label>
                    <!-- <input v-model="member.numero_de_documento" :disabled="fechaCorte"> -->
                    <input
                        :value="member.numero_de_documento"
                        @keydown="handleDocumentKeydown"
                        @input="updateDocumento(member, $event.target.value)"
                        
                        :disabled="fechaCorte  || grupo_activo == 0"
                      >
                </div>
                <div v-if="isFieldActive('tipo_de_documento')" class="grid-input-row">
                    <label >Tipo Documento</label>
                    <select v-model="member.tipo_de_documento" :disabled="fechaCorte  || grupo_activo == 0">
                        <option value="">-- Seleccione --</option>
                        <option value="CC">CC - Cédula de Ciudadanía</option>
                        <option value="CE">CE - Cédula de Extranjería</option>
                        <option value="Pasaporte">Pasaporte</option>
                    </select>
                </div>
                <div v-if="isFieldActive('categoria')" class="grid-input-row">
                    <label  >Categoría</label>
                    <input  v-model="member.categoria" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
            </div>
            <!-- <div v-if="numberOfActiveFields(member) > 0" :class="{'single-input': numberOfActiveFields(member) === 1, 'double-input': numberOfActiveFields(member) === 2}"> -->
            <div v-if="(isFieldActive('correo_electronico') || isFieldActive('telefono') || isFieldActive('indicativo_de_telefono') ||isFieldActive('ciudad') || isFieldActive('pais') || isFieldActive('direccion'))  ">


                <div v-if="isFieldActive('correo_electronico')" class="grid-input-row">
                    <label >Correo electrónico</label>
                    <!-- <input v-model="member.correo_electronico" :disabled="fechaCorte"> -->
                    <input
                      :value="member.correo_electronico"
                      @keydown="handleEmailKeydown"
                      @input="updateCorreo(member, $event.target.value)"
                      
                      :disabled="fechaCorte  || grupo_activo == 0"
                    >
                </div>
                <div v-if="isFieldActive('telefono')" class="grid-input-row">
                    <label >Teléfono</label>
                    <input :value="member.telefono" @input="updatePhoneNumber(member, $event.target.value)" :disabled="fechaCorte || grupo_activo == 0">
                </div>

                <div v-if="isFieldActive('indicativo_de_telefono')" class="grid-input-row">
                    <label >Indicativo  de teléfono</label>
                    <input v-model="member.indicativo_de_telefono" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>


                <div v-if="isFieldActive('direccion')" class="grid-input-row">
                    <label >Direccion</label>
                    <input v-model="member.direccion" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
                <div v-if="isFieldActive('ciudad')" class="grid-input-row">
                    <label >Ciudad</label>
                    <input v-model="member.ciudad" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
                <div v-if="isFieldActive('pais')" class="grid-input-row">
                    <label >País</label>
                    <input v-model="member.pais" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0"> 
                </div>
            </div>            

            <div v-if="(isFieldActive('empresa') || isFieldActive('profesion') || isFieldActive('especialidad'))">


                <div v-if="isFieldActive('empresa')" class="grid-input-row">
                    <label >Empresa</label>
                    <input v-model="member.empresa" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                    
                </div>
                <div v-if="isFieldActive('profesion')" class="grid-input-row">
                    <label  >Profesión</label>
                    <input  v-model="member.profesion" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
                <div v-if="isFieldActive('especialidad')" class="grid-input-row">
                    <label  >Especialidad</label>
                    <input  v-model="member.especialidad" @input="handleImmediateChange" :disabled="fechaCorte || grupo_activo == 0">
                </div>
            </div>
            <!-- Más campos como documento, correo electrónico, teléfono, etc. -->
            <div v-if="!fechaCorte && grupo_activo == 1" class="acciones-contenedor">
              <!-- Botón flotante lateral -->
              <button @click="toggleAcciones(index)" class="boton-toggle-acciones">
                ▶
              </button>

              <!-- Panel flotante de acciones -->
              <transition name="slide-left">
                <div v-if="accionAbierta === index" class="panel-acciones">
                  <div class="d-flex">
                    
                    <button @click="showModal(member, index)" v-if="member.staff_id" class="boton-aprobar">
                      <IconoConBorrar />
                    </button>
                  </div>
                  <div class="d-flex">
                    <button 
                    v-if="!groupsModified[groupId] && canApproveComputed(member) && mensajeDisponible && member.correo_electronico && member.nombres && member.apellidos" 
                    @click="enviarPreinvitacionIndividual(member)" 
                    class="bg-purple-500 hover:bg-purple-700 text-white font-bold py-2 px-1 rounded mt-2 boton-individual-pre-invitacion boton-aprobar"
                    >
                    Enviar invitación
                  </button>
                </div>
                  
                  <div class="mt-3" v-if="canView('superadministrador','administradorevento')">
                    <button v-if="canApproveComputed(member) && member.autorizado == '0'" @click="approveUser(member.staff_id, category)" class="bg-green-500 boton-aprobar hover:bg-green-700 text-white font-bold py-1 px-3 rounded">
                      Aprobar
                    </button>
                    <button v-if="checkPropAutorizado(member)">
                      <IconoAutorizado />                  
                    </button>
                  </div>
                </div>
              </transition>
            </div>

        </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import ProcesandoExcel from '../svgs/ProcesandoExcel.vue';
  import EstadoInicialExcel from '../svgs/EstadoInicialExcel.vue';
  import IconoConGuardar from '../svgs/IconoConGuardar.vue';
  import IconoConBorrar from '../svgs/IconoConBorrar.vue';
  // import FlechaRotativa from '../svgs/FlechaRotativa.vue';
  import IconoAutorizado from '../svgs/IconoAutorizado.vue';
  import { useToast } from "vue-toastification";

  export default {
    data() {
        return {
            // Define other data properties
            buttonClasses: 'bg-green-500 hover:bg-green-700 mr-5 button-excel text-white font-bold py-1 px-3 rounded',
            localFechaCorte: this.fechaCorte,  
            mensajeDisponible: false,    
            isOpen: true,      
            accionAbierta: null,
        };
    },
    mounted() {
      this.verificarMensajeDinamico();
    },
    setup() {      
      const toast = useToast();
      return { toast }
    },
    computed: {      
      roleToken() {
        return this.$store.state.user.token;
      },
    },
    props: {
        group: Object, // Recibe el objeto de grupo
        groupId: String,
        category: String,
        title: String,
        count: Number,
        members: Array,
        visible: Boolean,
        loading: Boolean,
        
        camposObligatorios: Object,
        fechaCorte: Boolean,
        grupo_activo: String,
        eventoToken: String,
        groupName: String,
        groupsModified: Object,
    },
    components: {
        ProcesandoExcel,
        EstadoInicialExcel,
        IconoConGuardar,
        IconoConBorrar,
        // FlechaRotativa,
        IconoAutorizado
    },
    inject: ['canView', 'canApproveComputed'],
    emits: ['trigger-file-input', 'file-changed', 'toggle-accordion', 'perform-save', 'approve-user', 'show-modal'],
    methods: {
      toggleAcciones(index) {
        this.accionAbierta = this.accionAbierta === index ? null : index;
      },
      
      async enviarPreinvitacionGrupal() {
        try {
          const payload = {
            id_grupo: this.groupId,
            nombre_grupo: this.groupName,
            token_evento:  this.eventoToken, 
            category: this.category,
            roleToken: this.roleToken
          };

          const res = await fetch('/api/preinvitacion/grupal', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload),
          });

          const data = await res.json();
          this.toast.success(data.mensaje || 'invitaciones enviadas');
        } catch (error) {
          this.toast.error('Error al enviar invitación grupal');
          console.error(error);
        }
    },
    async verificarMensajeDinamico() {
    try {
      const res = await fetch(`/api/mensaje-personalizado/${this.eventoToken}`);
      const result = await res.json();
      
      const contenido = result?.data?.contenido_html;

      this.mensajeDisponible = !!contenido && contenido.trim() !== '';
    } catch (error) {
      console.error("Error al verificar el mensaje dinámico:", error);
      this.mensajeDisponible = false;
    }
  },

    async enviarPreinvitacionIndividual(member) {
      try {
        const nombreCompleto = `${member.nombres} ${member.apellidos}`;
        const payload = {
          id_evento: this.eventoToken, // o usa evento.id si tienes otra forma de pasarla
          nombre_completo: nombreCompleto,
          nombre_grupo: this.groupName,
          correo: member.correo_electronico,
          roleToken: this.roleToken
        };

        const res = await fetch('/api/preinvitacion/individual', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });

        const data = await res.json();
        console.log(data);
        this.toast.success(`invitación enviada a ${nombreCompleto}`);
      } catch (error) {
        this.toast.error('Error al enviar invitación individual');
        console.error(error);
      }
    },

    handleImmediateChange() {
      this.$emit('group-modified', this.groupId);
      // Aquí puedes agregar más lógica si es necesario
    },
    //   sanitizeDocument(value) {
    //   const sanitized = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    //   if (sanitized !== value.toUpperCase()) {
    //     this.toast.warning("Este campo solo puede contener letras y números.");
    //   }
    //   return sanitized;
    // },
    // sanitizeEmail(value) {
    //   const sanitized = value.replace(/\s+/g, '');
    //   if (sanitized !== value) {
    //     this.toast.warning("Los espacios no están permitidos en el correo electrónico.");
    //   }
    //   return sanitized;
    // },
  handleDocumentKeydown(event) {
  // Permitir solo letras y números
    if (!/[a-zA-Z0-9]/.test(event.key) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault(); // Evitar que se maneje la tecla si no es válida
      this.toast.warning("Este campo solo puede contener letras y números.");
    }
  },
  handleEmailKeydown(event) {
    // Permitir caracteres válidos en un correo electrónico
    if (!/[a-zA-Z0-9@.-_]/.test(event.key) && !['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight'].includes(event.key)) {
      event.preventDefault(); // Evitar que se maneje la tecla si no es válida
      if (event.key === ' ') {
        this.toast.warning("Los espacios no están permitidos en el correo electrónico.");
      } else {
        this.toast.warning("Carácter no permitido en el correo electrónico.");
      }
    }
  },
    updateDocumento(member, value) {
      this.$emit('group-modified', this.groupId);
      const originalValue = value;
      value = value.toUpperCase().replace(/[^A-Z0-9]/g, '');
      if (value !== originalValue.toUpperCase()) {
        this.toast.warning("Este campo solo puede contener letras y números.");
      }
      member.numero_de_documento = value;
    },
    updateCorreo(member, value) {
      this.$emit('group-modified', this.groupId);
      const originalValue = value;
      value = value.replace(/\s+/g, '').replace(/[^a-zA-Z0-9@.-_]/g, '');
      if (!value.includes('@') || !value.includes('.')) {
        // this.toast.warning("Escribe un correo electrónico válido.");
      } else if (value !== originalValue) {
        this.toast.warning("Los espacios y caracteres especiales no están permitidos en el correo electrónico.");
      }
      member.correo_electronico = value;
    },
    numberOfActiveFields() {
        const fields = ['nombres', 'apellidos', 'numero_de_documento', 'correo_electronico', 'telefono', 'ciudad', 'pais', 'departamento', 'categoria', 'empresa', 'profesion', 'especialidad', 'direccion', 'indicativo_de_telefono'];
        return fields.reduce((count, field) => count + (this.isFieldActive(field) ? 1 : 0), 0);
    },

    isFieldActive(fieldLabel) {
        const field = this.camposObligatorios.find(f => f.label === fieldLabel);
        return field && field.activo;
    },
    cleanPhoneNumber(value) {
        // Filtra el valor permitiendo solo números y los caracteres específicos
        return value.replace(/[^0-9()\-[\]+/]/g, '');
    },
    updatePhoneNumber(member, newValue) {
      this.$emit('group-modified', this.groupId);
        member.telefono = this.cleanPhoneNumber(newValue);
    },
                  triggerFileInput() {
                      this.$emit('trigger-file-input', this.groupId ,this.category);
                  },

                  handleFileChange(event) {        
                      this.$emit('file-changed', event, this.groupId, this.category);
                  },
                  toggleAccordion() {
                      this.$emit('toggle-accordion', this.groupId, this.category);
                  },
    //   performSave() {
    //     this.$emit('perform-save', this.category, this.groupId);
    //   },
        performSave() {
            // Emitir al componente padre el intento de guardar con la categoría y ID del grupo específico
            
            // this.$emit('perform-save', this.groupId, this.category);
            this.$emit('perform-save', this.group, this.category);
        },
      showModal(member, index) {
        this.$emit('show-modal', this.group, this.category, index);
      },
      approveUser(staffId, category) {
        this.$emit('approve-user', staffId, category);
      },
      checkPropAutorizado(member) {
        // return member && member.autorizado === '1';
        if (member && 'autorizado' in member) {
            if (member.autorizado === "1") {
                return true; // El miembro está autorizado
            } else {
                return false; // El miembro no está autorizado
            }
        } else {
            return false; // Miembro no definido o sin la propiedad 'autorizado'
        }
      }
    }
  }
  </script>
  
  <style scoped>
  .table-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .rotate-button {
    cursor: pointer;
  }
  
.table-title {
    font-size: 1rem; /* 16px */
    font-weight: 600;
    padding-bottom: 1rem; /* 16px */
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding-top: 20px;
    position: relative;
    background: rgba(155,155,155, 0.1);
    border-radius: 15px;
    margin-bottom: 20px;
}
.table-title span{
    display: inline-block;
    min-width: 200px;
}


.input-label {
  display: block;
  font-size: 0.75rem;
  color: #6b7280; /* gray-500 */
  font-weight: 500;
  margin-bottom: 0.25rem;
}

.input-field {
  width: 100%;
  padding: 0.4rem 0;
  font-size: 0.875rem;
  border: none;
  border-bottom: 2px solid #e5e7eb;
  outline: none;
  background-color: transparent;
  transition: border-color 0.2s ease-in-out;
}

.input-field:focus {
  border-bottom-color: #6366f1; /* Indigo-500 */
}

.contenedor-label-input{
    text-align: left;
}
.lower {
    top: 48px; /* adjust based on your layout */
}

.lower-select {
    margin-top: 2.2rem; /* adjust based on your layout */
}

th, td {
  min-width: 120px; /* Ajusta según sea necesario */
  max-width: 200px; /* Ajusta según sea necesario */
}
input, select {
  width: 100%;
  box-sizing: border-box; 
}
button svg {
    fill: #fff;
    min-width: 20px;
}

table th {
    text-align: center;
}
table .td-top {
    vertical-align: top;

}

.accordion-content .contenedor-usuarios{
    border-radius: 7px;
    background: rgba(224, 224, 224, 0.05);    
    padding: 0px;
    /* display: block; */
    margin: 15px auto;
    padding: 10px;
    box-shadow: 2px 2px 10px rgba(155,155,155,0.5);
    display: flex;
    position: relative;
}
.accordion-content {
  transition: max-height 0.4s ease-in-out;
  overflow: hidden;
}
.rotate-button {
    min-height: 31px;
    min-width: 30px;
    box-shadow: 1px 2px 8px #999999;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 2px;
    position: absolute;
    right: 5vw;
    background: #fff;
    
} 
.rotate-button div {
  transition: transform 0.3s ease-in-out;  
}
.rotate-button div svg{  
  fill: #fff;
}

.rotate-180 {
  transform: rotate(180deg);
}
.button-excel {
    min-width: 20px;    
    color: white;
    padding: 8px 0.5rem;
    /* border-radius: 0.375rem; */
    display: inline-flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.15s ease-in-out;
}
.button-excel span{
    margin-left: 7px;
    font-size: 0.9em;
    min-width: 100px;
    /* max-width: 100px; */
}

.contenedor-label-input {
    width: 100%;  /* Utiliza todo el espacio disponible si está visible */
}

[v-if="!isFieldActive(...)"] {
    display: none;
}

td:empty {
    display: none;
}
select {
    padding: 3px 4px;
}
.contenedor-usuarios div {
    width: 90%;
}
.contenedor-usuarios div.acciones-contenedor {
    width: auto;
}
.botones-acciones {
    margin-left: auto;
    /* margin-right: 20px; */
    padding: 0 20px;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    max-width: 120px!important;
    
}
.contenedor-usuarios {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
  background-color: white;
  padding: 1.5rem 2.5rem 1.5rem 1.5rem; /* usa padding-right en shorthand */
  border-radius: 1rem;
  box-shadow: 0 2px 8px rgba(0,0,0,0.08);
  margin-bottom: 1.5rem;
  position: relative; /* ¡Importante! para el contexto absoluto interno */
  overflow: hidden;   /* opcional si no quieres que nada se desborde */
}

.button-clear{
  padding-right: 0;
}

.boton-grupal-pre-invitacion {
  font-size: 0.8em;
}
.boton-individual-pre-invitacion {
  font-size: 0.9em;
}
button {

  background: rgb(61, 67, 91)!important;
  border-radius: 3px!important;
}


select.input-field {
  appearance: none;
  border: none;
  border-bottom: 2px solid #e5e7eb;
  background-color: transparent;
  font-size: 0.875rem;
  padding: 0.4rem 3px;
}
select.input-field:focus {
  border-bottom-color: #6366f1;
  outline: none;
}
.grid-input-row {
  display: grid;
  grid-template-columns: 35% 65%;
  align-items: center;
  gap: 0.5rem;
  padding-block: 0.4rem;
}

.grid-input-row label {
  font-size: 0.875rem;
  font-weight: 500;
  color: #4b5563; /* gray-600 */
  padding-right: 0.5rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
}

.grid-input-row input,
.grid-input-row select {
  font-size: 0.875rem;
  width: 100%;
  border: none;
  border-bottom: 2px solid #e5e7eb;
  background-color: transparent;
  outline: none;
  padding: 0.35rem 0;
  box-sizing: border-box;
}

.grid-input-row input:focus,
.grid-input-row select:focus {
  border-bottom-color: #6366f1;
}



.acciones-contenedor {
  display: flex;
  align-items: stretch;
  /* position: relative; */
  position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: auto;
    margin: auto;
    justify-content: flex-end;
    padding-right: 5px; /* para que no quede pegado */
}

.boton-toggle-acciones {
  width: 30px;
  background-color: #e5e7eb!important;
  border: none;
  font-size: 1rem;
  font-weight: bold;
  cursor: pointer;
  border-radius: 5px 0 0 5px;
  transition: background 0.2s ease;
}
.boton-toggle-acciones:hover {
  background-color: #d1d5db;
}

.panel-acciones {
  position: absolute;
  right: 30px;
  top: 0;
  height: 100%;
  background: #fff;
  border: 1px solid #ccc;
  box-shadow: -2px 2px 8px rgba(0, 0, 0, 0.1);
  padding: 0.75rem;
  display: flex;
  flex-direction: column;
  z-index: 50;
  min-width: 180px;
  max-width: 300px;
  border-radius: 8px 0 0 8px;
}

/* Animación */
.slide-left-enter-active,
.slide-left-leave-active {
  transition: transform 0.3s ease, opacity 0.3s ease;
}
.slide-left-enter-from,
.slide-left-leave-to {
  transform: translateX(100%);
  opacity: 0;
}
.boton-aprobar{
  width: 100%;

}
.botones-header {
  display: flex;
}

  </style>
  